"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = signedIn;

var _noty = require("noty");

function signedIn() {
  (0, _noty.showNotificationText)('You have been signed in.');
}